import React from 'react';

import {
  BlankLayout,
  CardLayout,
  FullscreenLayout,
  LayoutType,
  PublicFullscreenLayout,
} from '@sandtech-hub-monorepo/ui-kit';
import { Footer } from '../app/Footer';
import {
  Header,
  usePlatforms as getPlatforms,
} from '@sandtech-hub-monorepo/ui-kit-site';
import { AppRoutesPaths } from '../routes/types';

export const RouteWithLayout: React.FC<{
  layout: LayoutType;
  children: React.ReactNode;
}> = ({ layout, children }) => {
  const rootDomain = process.env['NX_COOKIE_DOMAIN'] || '';
  const { current } = getPlatforms(rootDomain);

  switch (layout) {
    case LayoutType.Fullscreen:
      return (
        <FullscreenLayout
          children={children}
          className="bg-background"
          header={
            <div className="print:hidden">
              <Header
                className="bg-card text-foreground shadow-none border-b border-border-secondary"
                sdk={false}
                homeRoute={'/'}
                withLogo={true}
                hasThemeSwitcher={false}
                apps={current.apps}
                showNotifications={false}
                settingsApps={[
                  /*
                TODO: We gotta extract these using the "getPlatforms"
                hook and make it accept local host too. And then we have to fix this
                for the central hub corresponding component. */
                  {
                    name: 'Settings',
                    route: AppRoutesPaths.Settings,
                    iconName: 'SettingsIcon',
                    followedBySeparator: true,
                  },
                ]}
                rewardsLink={undefined}
                logo={current.logo}
              />
            </div>
          }
          footer={
            <div className="print:hidden">
              <Footer />
            </div>
          }
        />
      );
    case LayoutType.PublicFullscreen:
      return (
        <PublicFullscreenLayout
          children={children}
          footer={
            <div className="print:hidden">
              <Footer />
            </div>
          }
        />
      );
    case LayoutType.Card:
      return <CardLayout children={children} />;
    default:
      return <BlankLayout children={children} />;
  }
};
